import { apiV2AuthRoot } from './instances.js'
import service from './services/service.js'
import auth from './services/auth.js'
import kaufland from "@/api/services/kaufland";

export const api = {
  service: service(apiV2AuthRoot),
  auth: auth(apiV2AuthRoot),
  kaufland: kaufland(apiV2AuthRoot),
}
